import {isArray,isObject,clearNullValueWithinObject} from "my-tools-kit";
/* 搜索
  <el-form
        :model="searchData"
        ref="searchForm"
        label-width="70px"
        size="mini"
        :inline="true"
        @submit.native.prevent="search"
    >
      <el-form-item label="订单号">
        <el-input placeholder="订单号或自有单号"
                  v-model="searchData.nos"
                  @clear="search"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary"
                   icon="el-icon-search"
                   @click="search">查询</el-button>
      </el-form-item>

    </el-form>
 */

/* 表格
<el-table :data="tableData"
              v-loading="pagingParams.loading"
              :header-cell-style="elTableParams.headerCellStyle"
              :size="elTableParams.size"
              max-height="400px">
</el-table>
 */

/* 分页1
<common-pagination :config="pagingConfig"></common-pagination>
 */

/* 分页2
<el-pagination class="common-pagination"
                  v-loading="pagingParams.loading"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :total="pagingParams.total"
                   :current-page="pagingParams.currentPage"
                   :page-size="pagingParams.pageSize"
                   :page-sizes="pagingParams.sizes"
                   :layout="pagingParams.layout"
></el-pagination>
*/

/**
 * 通用分页
 */
export const mixinsPaging = {
  data() {
    return {
      elTableParams: {
        headerCellStyle: {background: "#F3F3F3", color: "#999999"},
        size: "mini",
      },
      /* 筛选 */
      searchData: {
        searchType: "",
        searchValue: "",
      },
      /* 表格 */
      tableData: [],
      tableDataSelectValue: [],
      /* 分页参数 */
      pagingParams: {
        loading: false,
        total: 10,
        pageSize: 10,
        currentPage: 1,
        sizes: [10, 20, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        mapKeys:{
          total:"total",
          list:"list",
        },
      },
    }
  },
  computed: {
    // pagingConfig() {
    //   return {
    //     sizeChange: this.handleSizeChange,
    //     currentChange: this.handleCurrentChange,
    //     ...this.pagingParams,
    //   }
    // }
  },
  methods: {
    /**
     * 拼接搜索参数
     */
    jointSearchData(...arg) {
      let data = {
        curPage: this.pagingParams.currentPage,
        pageSize: this.pagingParams.pageSize,
      };
      data = Object.assign(data, this.searchData, ...arg);
      disposeSearchData(data);
      return data;
    },
    /**
     * 搜索
     */
    search() {
      this.handleCurrentChange();
    },
    /**
     * 请求列表数据，涉及axios的请求放在该方法中
     */
    requestListData() {
      let data = this.jointSearchData();
      // return this.axios.get("/test", data);
      return Promise.resolve({
        code: 0,
        message: "这是demo,请使用正式请求覆盖 this.requestListData()",
      })
    },
    /**
     * 获取列表
     */
    getList() {
      this.pagingParams.loading = true;
      this.requestListData()
        .then(res => {
          this.pagingParams.loading = false;
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          if (isObject(res.data)) {
            let list;
            let key = this.pagingParams.mapKeys;
            if (isArray(res.data[key.list])) list = res.data[key.list];
            // else list = getFirstArrayInObject(res.data);
            this.tableData = list || [];
            let total = parseInt(res.data[key.total]);
            this.pagingParams.total = total || 0 ;
          }
          return res;
        })
        .catch(res => {
          if(this.$message) this.$message.error(res.message || "服务器繁忙");
          this.pagingParams.loading = false;
          this.tableData = [];
          this.pagingParams.total = 10;
        });
    },
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pagingParams.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.pagingParams.currentPage = val;
      this.getList();
    },
    /**
     * 其他
     */
    /*选择变化*/
    handleSelectionChange(value) {
      this.tableDataSelectValue = value;
    },
  },
};


/**
 * 处理搜索数据
 * @param data
 */
export function disposeSearchData(data) {
  if (data.searchType && data.searchValue) {
    data[data.searchType] = data.searchValue
  }
  if (data.searchType) delete data.searchType;
  if (data.searchValue) delete data.searchValue;
  clearNullValueWithinObject(data);
  return data
}

/**
 * 获取 对象中的第一个数组
 */
export function getFirstArrayInObject(data) {
  for (const key in data) {
    const item = data[key];
    if (isArray(item)) return item;
  }
  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-element-mixins/src/mixins/paging.js
// module id = null
// module chunks = 